export default "__VITE_ASSET__Lptixk6t__"